// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileAddOutlinedSvg from "@fishx/icons-svg/es/asn/FileAddOutlined";
import FishxIcon from '../components/FishxIcon';

var FileAddOutlined = function FileAddOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileAddOutlinedSvg
  }));
};

FileAddOutlined.displayName = 'FileAddOutlined';
export default React.forwardRef(FileAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileAddOutlined.js
// module id = 2681
// module chunks = 0